import React from "react";
import { connect } from "react-redux";

import { Route, Switch, useHistory, useRouteMatch } from "react-router-dom";

import Path from "@app/enum/Path";
import { isResourcesEnabled } from "@app/store/iam";
import { RootState } from "@app/store/rootReducer";
import AnalyticsContext from "@app/util/contexts/AnalyticsContext";

import FilePage from "./FilePage";
import ResourcePage from "./ResourcePage";
import resourceAnalytics from "./utils/resourceAnalytics";

interface Props {
  resourcesEnabled: boolean;
}

const Resources: React.FC<Props> = ({ resourcesEnabled }) => {
  const { path } = useRouteMatch();
  const history = useHistory();

  if (!resourcesEnabled) {
    history.push(Path.DASHBOARD);
    return null;
  }

  return (
    <AnalyticsContext.Provider value={resourceAnalytics}>
      <Switch>
        <Route path={[`${path}/files/:resourceId`, `${path}/folders/:folderId`, path]}>
          <ResourcePage />
          <Route
            path={[`${path}/files/:resourceId`, `${path}/folders/:folderId/files/:resourceId`]}
            component={FilePage}
          />
        </Route>
      </Switch>
    </AnalyticsContext.Provider>
  );
};

const mapStateToProps = (state: RootState) => ({
  resourcesEnabled: isResourcesEnabled(state),
});

export default connect(mapStateToProps)(Resources);
